import { Store } from "../Store.dt";
import { LOGIN, LOGOUT } from "./AuthType"

export const initialStateAuth = {
    isLogin: null,
    // isInitialized: false,
    // user: null
};

function AccountReducer(state = initialStateAuth, action: Store) {
    switch (action.type) {
        case LOGIN:
            return { ...action.payload }
        case LOGOUT:
            return { ...action.payload }
        default:
            return state
    }

}
export default AccountReducer